export const hasAllocationMapMarker = row => !!row?.dropMapMarker
    || !!String(row?.mapMarkerAddress || row?.mapMarkerName || '').trim()
    || (Array.isArray(row?.mapMarkerCoordinates) && row.mapMarkerCoordinates.length >= 2)

// A marker name ("Meeting point") is a label, not an address, and the original
// site address is the wrong place once a marker overrides it -- navigation goes
// to the marker's coordinates. Show neither; the name still renders as the site.
export const getAllocationDisplayAddress = row => hasAllocationMapMarker(row)
    ? String(row?.mapMarkerAddress || '').trim() || '-'
    : row?.siteAddress || '-'

export const getAllocationNavigationCoordinates = row => hasAllocationMapMarker(row)
    ? row?.mapMarkerCoordinates
    : row?.siteCoordinates
